<div class="trek-game" [class.is-immersive]="isFullscreen" *ngIf="round">

  <!-- Prompt: A op B (mixed numbers) -->
  <div class="prompt-bar">
    <span class="prompt-text">{{ currLang === 'ar' ? 'حرّك العلامة إلى' : 'Move the marker to' }}</span>
    <span class="expr" *ngIf="aParts as a">
      <span class="mixed">
        <span class="w" *ngIf="a.whole > 0 || a.num === 0">{{ a.whole }}</span>
        <span class="frac" *ngIf="a.num > 0"><span class="n">{{ a.num }}</span><span class="bar"></span><span class="d">{{ a.den }}</span></span>
      </span>
      <span class="op">{{ opSign }}</span>
      <span class="mixed" *ngIf="bParts as b">
        <span class="w" *ngIf="b.whole > 0">{{ b.whole }}</span>
        <span class="frac" *ngIf="b.num > 0"><span class="n">{{ b.num }}</span><span class="bar"></span><span class="d">{{ b.den }}</span></span>
      </span>
    </span>
  </div>

  <!-- Whose turn -->
  <div class="turn-chip" *ngIf="student">
    <app-student-avatar [student]="student" [size]="46" [active]="true"></app-student-avatar>
    <div class="turn-text">
      <span class="turn-name">{{ studentName }}</span>
      <span class="turn-label">{{ currLang === 'ar' ? 'دورك!' : "it's your turn" }}</span>
    </div>
  </div>

  <!-- Round progress -->
  <div class="round-dots">
    <span class="dot" *ngFor="let d of roundDots; let i = index"
          [class.done]="solvedFlags[i]" [class.current]="i === currentRound"></span>
  </div>

  <!-- Interactive stage -->
  <div class="stage-wrap">
    <app-fraction-trek-stage
      [round]="round"
      [roundKey]="currentRound"
      [interactive]="!resolving"
      [currLang]="currLang"
      (solved)="onSolved()"
      (missed)="onMissed()">
    </app-fraction-trek-stage>
  </div>

  <!-- Controls -->
  <div class="controls">
    <button class="ctrl-btn check-btn" [disabled]="resolving || !stage?.canCheck" (click)="onCheck()">
      {{ currLang === 'ar' ? 'تحقّق' : 'CHECK' }}
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <button class="ctrl-btn skip-btn" [disabled]="resolving" (click)="skip()">
      {{ currLang === 'ar' ? 'تخطّي' : 'Skip' }}
    </button>
  </div>

  <!-- Success: equation banner at the top so the line stays clear -->
  <div class="success-overlay" *ngIf="showSuccess">
    <div class="success-card">
      <span class="success-icon" aria-hidden="true">🧭</span>
      <span class="success-eq">{{ equationLabel }}</span>
      <span class="success-xp" *ngIf="lastXp > 0">+{{ lastXp }} XP</span>
    </div>
  </div>

  <app-fullscreen-toggle [isFullscreen]="isFullscreen" [currLang]="currLang" (toggle)="toggleFullscreen()"></app-fullscreen-toggle>
</div>
